<script setup lang="ts">
    import { Button } from '@/components/ui/button';
    import { Plus } from 'lucide-vue-next';

    withDefaults(
        defineProps<{
            buttonText?: string;
        }>(),
        {
            buttonText: 'tables.create',
        },
    );
</script>

<template>
    <Button
        variant="ghost"
        width="narrow"
        class="self-start"
        size="xs"
    >
        <span>{{ $t(buttonText) }}</span>
        <Plus class="text-accent size-3.5" />
    </Button>
</template>
